import React, { useEffect, useState } from 'react'
import { AddToCategory_ObjectInstance_Api, GetById_ObjectInstance_Api, RemoveFromCategory_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { AllCategoryComponent } from '../Category/AllCategoryComponent';
import { Button, Row,Col } from 'antd';
import { CloseOutlined, DoubleRightOutlined, RollbackOutlined } from '@ant-design/icons';

// =================================================================
export const EditObjectInstanceCategoryComponent = ({ setLoading, showMessage, objectInstanceId, onBackClick }) => {
    // =================================================================
    const [objectInstance, setObjectInstance] = useState();
    // =================================================================
    useEffect(() => {
        loadData();
    }, [objectInstanceId]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectInstance_Api(objectInstanceId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectInstance(data.messageData.data);
            }
            else 
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const categoryChanged = async (catId, checked) => {
        setLoading(true);
        try {
            let data;
            if (checked)
                data = await AddToCategory_ObjectInstance_Api({ "objectInstanceId": objectInstanceId, "categoryId": catId });
            else
                data = await RemoveFromCategory_ObjectInstance_Api({ "objectInstanceId": objectInstanceId, "categoryId": catId });

            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            {objectInstance ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {objectInstance.title}
                        </h2>
                    </div>
                    <div className='container'>
                        <AllCategoryComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            parentId={-1}
                            isShowAddSubCategory={false}
                            isShowEdit={false}
                            isShowDelete={false}
                            isLoadObjectInstanceCategories={true}
                            isLoadCategoryFromParam={false}
                            isShowCheckBox={true}
                            onCheckChange={(catId, checked) => { categoryChanged(catId, checked) }}
                            objectInstanceId={objectInstanceId}
                        />
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={16} sm={16} md={16} lg={20} xl={20} >
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => onBackClick()}>
                                <DoubleRightOutlined />
                                بازگشت </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}